import { useWizard } from "react-use-wizard";
import { toReadablePrice } from "../../../../../../../../lib/utils";
import RangeByRegionByFacilityTypeStep from "../../../../../../../shared/wizard/steps/rangeByRegionByFacilityTypeStep";
import buySteps from "../../buySteps";

interface ISelectionByOwnSwapStep_8 {
  typeIds: number[] | null;
  selectedPolygonIds: number[] | null;
}

const SelectionByOwnSwapStep_8 = ({
  typeIds,
  selectedPolygonIds,
}: ISelectionByOwnSwapStep_8) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_7);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_9);
  };

  return (
    <div>
      <RangeByRegionByFacilityTypeStep
        selectedPolygonIds={selectedPolygonIds ?? []}
        typeIds={typeIds ?? []}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
      />
    </div>
  );
};
export default SelectionByOwnSwapStep_8;
